import type { FormInstance } from 'element-plus'

/**
 * Resets form, clears upload files.
 *
 * @param formEl form instance.
 */
export const resetForm = (formEl: FormInstance | undefined) => {
  formEl?.resetFields()
}
